import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import { Select, Option } from "@material-tailwind/react";
import React from "react";
import { ArrowDownIcon } from "@heroicons/react/24/solid";
import PolicyIcon from "@mui/icons-material/Policy";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import ManageAccountsSharpIcon from "@mui/icons-material/ManageAccountsSharp";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  Chip,
  TabPanel,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { getInventoryAwsData } from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import ExcelJS from "exceljs";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";
import moment from "moment";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const TABLE_HEAD = [
  "Account Id",
  "Type",
  "Name",
  "ARN",
  "Policies",
  "Creation Time",
];

const data = [
  {
    label: "AWS Managed",
    value: "AWSManaged",
  },
  {
    label: "Customer Managed",
    value: "CustomerManaged",
  },
];

export default function InventoryAWS() {
  const navigate = useNavigate();
  const { refreshToken } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [service, setService] = useState("");
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [type, setType] = useState("");
  const [accountId, setAccountId] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [policyData, setPolicyData] = useState([]);
  const [activeTab, setActiveTab] = useState("AWSManaged");
  const [tableHead, setTableHead] = useState(["S no.", "Policy ARN"]);
  const [open, setOpen] = useState(false);
  const handleOpen = (item) => {
    setPolicyData(item);
    setOpen((cur) => !cur);
  };

  useEffect(() => {
    getInventoryAwsData(
      refreshToken,
      searchBy,
      sortBy,
      limit,
      page,
      type,
      accountId,
      service
    ).then((data) => {
      console.log(data);
      if (data?.code === 403) {
        navigate("/403");
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTotalPage(data?.data?.totalPages);
      setTemplateData(data?.data);
      setIsLoading(false);
    });
  }, [page, limit, sortBy, searchBy, type, accountId, refreshToken]);

  useEffect(() => {
    if (activeTab === "AWSManaged") {
      setTableHead(["S no.", "Policy ARN"]);
    } else {
      setTableHead(["S no.", "Policy Name", "Policy Documnent"]);
    }
  }, [activeTab]);

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("AWS Data");
    const headers = [...tableHead];

    worksheet.addRow(headers);

    // templateData.forEach((row, index) => {
    //   worksheet.addRow([
    //     index + 1,
    //     row.userName,
    //     row.userEmail,
    //     row.role,
    //     row.status,
    //   ]);
    // });
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "inventory_AWS.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="app-main__inner !pl-20 ">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of IAM resources
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all IAM users, roles, groups and policies across all AWS
                accounts
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                onClick={exportToExcel}
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              <Button
                className="flex items-center gap-3"
                size="sm"
                loading={isLoading === null ? true : false}
              >
                <AccountTreeIcon strokeWidth={2} className="h-4 w-4" />
                <span className="hidden md:inline-block"> Identity Graph</span>
              </Button>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                className="!border-t-0 !border-[#b0bec5]"
                label="Select Limit"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                className="!border-t-0 !border-[#b0bec5]"
                label="Sort By"
                value={sortBy}
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              <Select
                color="green"
                className="!border-t-0 !border-[#b0bec5]"
                animate={{
                  mount: { y: 0 },
                  unmount: { y: 25 },
                }}
                label="Account ID"
                onChange={(event) => {
                  setAccountId(event);
                  setIsLoading(null);
                }}
                value={accountId}
              >
                <Option value="">All Data</Option>
                {templateData && templateData.length > 0 ? (
                  templateData.map((item) => (
                    <Option key={item.accountId} value={item.accountId}>
                      {item.accountId}
                    </Option>
                  ))
                ) : (
                  <Option value="">Loading...</Option>
                )}
              </Select>
              <Select
                color="yellow"
                className="!border-t-0 !border-[#b0bec5]"
                label="Type"
                value={type}
                onChange={(event) => {
                  setType(event);
                  setIsLoading(null);
                }}
              >
                <Option value="">All Data</Option>
                <Option value="users">User</Option>
                <Option value="policies">Policy</Option>
                <Option value="groups">Group</Option>
                <Option value="roles">Role</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-3 p-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-32"
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                    >
                      {head}
                      {index !== TABLE_HEAD.length - 1 && (
                        <ChevronUpDownIcon
                          strokeWidth={2}
                          className="h-4 w-4"
                        />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <tbody>
                  {isLoading === false && templateData?.length > 0 ? (
                    templateData.map(({ accountId, iam }, index) => {
                      const isLast = index === templateData.length - 1;
                      const classes = isLast
                        ? "p-3"
                        : "p-3 border-b border-blue-gray-50";

                      return Object.keys(iam).map((iamType) => {
                        return Object.keys(iam[iamType]).map(
                          (itemName, itemIndex) => {
                            const item = iam[iamType][itemName];
                            const arn =
                              item?.responseElements?.user?.arn ||
                              item?.responseElements?.role?.arn ||
                              item?.responseElements?.group?.arn ||
                              item?.responseElements?.policy?.arn ||
                              "-";
                            return (
                              <tr key={`${accountId}-${itemIndex}-${itemName}`}>
                                <td className={classes}>
                                  <div className="flex items-center gap-3">
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal"
                                    >
                                      {accountId}
                                    </Typography>
                                  </div>
                                </td>
                                <td className={classes}>
                                  <div className="w-max">
                                    <Chip
                                      variant="outlined"
                                      className={`py-1.5 ${
                                        iamType === "policies"
                                          ? "!border-blue-500 !text-blue-600"
                                          : iamType === "users"
                                          ? "!border-green-500 !text-green-600"
                                          : iamType === "roles"
                                          ? "!border-orange-500 !text-orange-600"
                                          : iamType === "groups"
                                          ? "!border-purple-500 !text-purple-600"
                                          : "!border-blue-gray-500 !text-blue-gray-600"
                                      }`}
                                      icon={
                                        iamType === "policies" ? (
                                          <PolicyIcon className="p-[2px]" />
                                        ) : iamType === "users" ? (
                                          <PersonIcon className="p-[2px]" />
                                        ) : iamType === "roles" ? (
                                          <ManageAccountsSharpIcon className="p-[2px]" />
                                        ) : iamType === "groups" ? (
                                          <GroupsIcon className="p-[2px]" />
                                        ) : null
                                      }
                                      value={
                                        iamType === "policies"
                                          ? "Policy"
                                          : iamType === "users"
                                          ? "User"
                                          : iamType === "roles"
                                          ? "Role"
                                          : iamType === "groups"
                                          ? "Group"
                                          : null
                                      }
                                    />
                                  </div>
                                </td>
                                <td className={classes}>
                                  {itemName.length > 40 ? (
                                    <TableRowWithShowMore data={itemName} />
                                  ) : (
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-normal w-60 !text-wrap"
                                    >
                                      {itemName}
                                    </Typography>
                                  )}
                                </td>
                                <td className={classes}>
                                  <div className="flex flex-col">
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="font-bold"
                                    >
                                      {arn.length > 40 ? (
                                        <TableRowWithShowMore data={arn} />
                                      ) : (
                                        <Typography
                                          variant="small"
                                          color="blue-gray"
                                          className="font-normal w-56 !text-wrap"
                                        >
                                          {arn}
                                        </Typography>
                                      )}
                                    </Typography>
                                    <Typography
                                      variant="small"
                                      color="blue-gray"
                                      className="text-[14px] font-medium"
                                    >
                                      {item?.region}
                                    </Typography>
                                  </div>
                                </td>
                                <td className={classes}>
                                  <Tooltip
                                    content="view policies"
                                    className="bg-blue-gray-500"
                                  >
                                    <Button
                                      variant="gradient"
                                      size="sm"
                                      onClick={() => handleOpen(item?.policies)}
                                    >
                                      <span>Policies</span>
                                    </Button>
                                  </Tooltip>
                                </td>
                                <td className={classes}>
                                  <Chip
                                    variant="ghost"
                                    size="sm"
                                    value={
                                      item?.createTime
                                        ? moment(item?.createTime).format(
                                            "MMMM DD, YYYY"
                                          )
                                        : ""
                                    }
                                    className="rounded-full w-fit text-xs	normal-case font-medium	"
                                  />
                                </td>
                              </tr>
                            );
                          }
                        );
                      });
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div className="flex flex-col items-center w-full">
                          <img
                            quality={100}
                            src="/assets/images/9276430.jpg"
                            className="w-[350px] mix-blend-darken"
                            alt="no-data-found"
                          />
                          <p className="text-[20px] font-medium">
                            No Data Found!
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>
            )}
          </table>
        </CardBody>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setIsLoading(null);
                  setPage(page - 1);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setIsLoading(null);
                      setPage(index + 1);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>

      {/* Policy Functionality */}
      <Dialog
        size="md"
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <Card className="mx-auto w-full h-[550px]">
          <Typography variant="h4" color="blue-gray" className="p-4">
            {activeTab === "CustomerManaged" ? "Customer " : "AWS "}Managed
          </Typography>
          <Tabs id="custom-animation" value={activeTab}>
            <TabsHeader className="mx-4">
              {data.map(({ label, value }) => (
                <Tab
                  key={value}
                  value={value}
                  onClick={() => setActiveTab(value)}
                  className={activeTab === value ? "text-gray-900" : ""}
                >
                  {label}
                </Tab>
              ))}
            </TabsHeader>
            <TabsBody
              animate={{
                initial: { y: 250 },
                mount: { y: 0 },
                unmount: { y: 250 },
              }}
            >
              {data.map(({ value }) => (
                <TabPanel key={value} value={value}>
                  <CardBody className="overflow-y-auto max-h-[calc(550px-150px)] !p-0">
                    <table className="mt-1 w-full min-w-max table-auto text-left">
                      <thead>
                        <tr>
                          {tableHead.map((head) => (
                            <th
                              key={head}
                              className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-28"
                            >
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                              >
                                {head}
                              </Typography>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {activeTab === "AWSManaged" &&
                        policyData?.AWSManaged?.length > 0 ? (
                          policyData.AWSManaged.map((item, index) => {
                            const isLast =
                              index === policyData.AWSManaged.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            return (
                              <tr key={index}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal w-16"
                                  >
                                    {index + 1}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {item?.policyArn ||
                                      item?.requestParameters?.policyArn}
                                  </Typography>
                                </td>
                              </tr>
                            );
                          })
                        ) : activeTab === "CustomerManaged" &&
                          policyData?.CustomerManaged?.length > 0 ? (
                          policyData.CustomerManaged.map((item, index) => {
                            const isLast =
                              index === policyData.CustomerManaged.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            return (
                              <tr key={index}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {index + 1}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {item?.requestParameters?.policyName}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {item?.requestParameters?.policyDocument}
                                  </Typography>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="8">
                              <div className="flex flex-col items-center w-full">
                                <img
                                  src="/assets/images/9276430.jpg"
                                  className="w-[200px] mix-blend-darken"
                                  alt="no-data-found"
                                />
                                <p className="text-[20px] font-medium">
                                  No Policy Found!
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </CardBody>
                </TabPanel>
              ))}
            </TabsBody>
          </Tabs>
          <CardFooter className="flex justify-end mt-auto items-end border-t-2 py-2">
            <Button
              variant="text"
              color="red"
              onClick={() => {
                setOpen((cur) => !cur);
                setActiveTab("AWSManaged");
              }}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
          </CardFooter>
        </Card>
      </Dialog>
      {/* End Policy Functionality */}
    </div>
  );
}
